import type { EmsComponents, NormalizedNullableResponse } from '../../api/ems';
import { normalizePortalLocation } from './location';
import type { PortalLocation } from './location';

type GeneratedPortalCallWire = EmsComponents['schemas']['PortalCall'];

export type DataSourceKind = GeneratedPortalCallWire['sourceKinds'][number];

export type PortalCallWire = Omit<GeneratedPortalCallWire, 'lastLocation'> & {
  lastLocation?: PortalLocation | null;
};

type NormalizedPortalCall = NormalizedNullableResponse<PortalCallWire>;

export type PortalCall = Omit<NormalizedPortalCall, 'lastLocation'> & {
  lastLocation: PortalLocation | null;
};

export function normalizePortalCall(call: GeneratedPortalCallWire): PortalCall {
  const wire = call as unknown as PortalCallWire;

  return {
    ...call,
    endTimeUtc: call.endTimeUtc ?? null,
    lastLocation: wire.lastLocation == null ? null : normalizePortalLocation(wire.lastLocation),
  };
}
